import { SoundWave } from './SoundWave'

// 取代状态文字尾部的"…":三个错相位上下跳动的小圆点
function Dots() {
    return (
        <span className="ml-1 inline-flex items-center gap-[3px]">
            {[0, 1, 2].map((i) => (
                <span
                    key={i}
                    className="inline-block h-1 w-1 shrink-0 rounded-full bg-current"
                    style={{ animation: 'dot-bounce 1.1s ease-in-out infinite', animationDelay: `${i * 0.16}s` }}
                />
            ))}
        </span>
    )
}

export function StatusLine({
    text,
    active,
    listening,
    capturing,
    danger
}: {
    text: string
    active: boolean
    listening: boolean
    capturing: boolean
    danger: boolean
}) {
    const indicator = capturing || listening
    const dotted = text.endsWith('…') // 思考/说话态尾部的"…"→ 跳动圆点
    return (
        // 两行:指示(音波/待命点)在上,状态文字在下。固定高度,状态切换不抖动页脚。
        <div className="mb-2 flex h-11 flex-col items-center justify-center gap-1 text-sm text-text-secondary">
            {indicator && (
                <div className="flex h-5 items-center">
                    {/* ASR 真正在录(VAD 触发或长按)→ 音波(取消态转红);只是 VAD 待命未说话 → 脉动蓝点 */}
                    {capturing ? (
                        <span className={danger ? 'text-destructive' : 'text-accent'}>
                            <SoundWave heightClass="h-5" />
                        </span>
                    ) : (
                        <span className="h-2 w-2 animate-pulse rounded-full bg-accent" />
                    )}
                </div>
            )}
            {active && (
                <div className="flex items-center">
                    {dotted ? text.slice(0, -1) : text}
                    {dotted && <Dots />}
                </div>
            )}
        </div>
    )
}
